import React, { HTMLAttributes } from 'react'
import clsx from 'clsx'

export interface BubbleProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  variant: BubbleVariant
  size?: 'lg' | 'md' | 'sm'
}
export type BubbleVariant = "green" | "red" | "grey" | "forestGreen" | "darkBlue" | "lightBlue";

export const Bubble = ({
  children,
  variant,
  size = 'md',
  className,
  ...attrs
}: BubbleProps) => {
  return (
    <div
      className={clsx('inline-block whitespace-nowrap p-2', className, {
        'bg-positiveGreen text-black': variant === 'green',
        'bg-negativeRed text-white': variant === 'red',
        'bg-midGray text-white': variant === 'grey',
        'bg-forestGreen text-white': variant === 'forestGreen',
        'bg-darkBlue text-white': variant === 'darkBlue',
        'bg-lightBlue text-white': variant === 'lightBlue',
        'text-xs': size === 'sm',
        'text-sm': size === 'md',
        'text-lg': size === 'lg',
      })}
      {...attrs}
    >
      {children}
    </div>
  )
}
